// extracted by mini-css-extract-plugin
module.exports = {"rating":"RatingInput_rating__DJaax","ratechange":"RatingInput_ratechange__5pG-Y"};